<template>
  <div class="box">
    <div class="loading" >努力加载中…</div>
  </div>
</template>
<style scoped>
  .box{
    display: table;
    text-align: center;
    width: 100%;height: 100%;
  }
  .loading{display: table-cell;vertical-align: middle;width: 100%;height: 100%;}
</style>
<script>
  export default {
    data () {
      return {
      }
    },
    created () {
      window.location.href = 'http://m.ismartv.cn'
    }
  }
</script>



// WEBPACK FOOTER //
// loginSuccess.vue?edfa15b4